export default __webpack_public_path__ + "static/media/Akhmerov_Timur_Maratovich.41a9797b.webp";